module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-left-panel-2-edfcee7fc9470f754faa806693918060.svg";